import { map } from "../../map.sideEffects/useMap.sideEffects.js";
import { sourceIds } from "../../variables/sourceIds.js";
import { setFeaturesGhosted } from "../filter.map.js";

export function filterPOIChildren(allFilters, level) {
  setFeaturesGhosted([map.getSource(sourceIds.poiChildren)], level);
}
